import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  MdiCouponOutline
} from "../../assets/icons/icons";
import {
  LayoutTemplate,
  ClipboardList,
  ArrowRightLeft,
  User,
  Users,
  Box,
} from "lucide-react";
import logo from "../../assets/admin/logo.svg";
import logoName from "../../assets/admin/Name.svg";
import { useSession } from "../layout/SessionContext";

const SideNavBar = ({ isSidebarVisible }) => {
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState(null);
  const { hasPermission } = useSession();

  // Accept a callback prop to hide sidebar
  const handleNavClick = (to) => {
    if (window.innerWidth < 768) {
      // Custom event to notify parent to hide sidebar
      const event = new CustomEvent('hideSidebar');
      window.dispatchEvent(event);
    }
  };

  const navigationItems = [
    { path: "/dashboard", label: "Dashboard", icon: LayoutTemplate, permissionKey: "dashboard" },
    { path: "/orders", label: "Orders", icon: ClipboardList,  permissionKey: "order"},
  { path: "/products", label: "Products", icon: Box, permissionKey: "product"  },
    { path: "/simswap", label: "Sim swap", icon: ArrowRightLeft,  permissionKey: "simSwap" },
    { path: "/customers", label: "Customers", icon: User,  permissionKey: "customer" },

    { path: "/promocode", label: "Referral Code", icon: MdiCouponOutline, permissionKey: "referralCode"  },
    { path: "/manageUsers", label: "Manage users", icon: Users, permissionKey: "manageUser" },
  ];

  return (
    <div
      className={`
        ${isSidebarVisible ? "w-52" : "w-24"}
        bg-white md:bg-[#E5E7EB]
        top-0 h-screen transition-all duration-300 overflow-y-auto z-10
      `}
    >
      <div className="">
        {/* Logo Section - only render on md and up */}
        <div className="hidden md:block px-4 py-4 border-gray-200 h-full">
          <div className="flex items-center gap-0 mb-2 mt-2 ml-3">
            <img
              src={logo}
              alt="Bereload Logo"
              className="transition-all w-10 h-10 ml-1"
            />
            {isSidebarVisible && (
              <img src={logoName} alt="Bereload Name" className="w-23 h-8" />
            )}
          </div>
        </div>

        {/* Navigation Links */}
        <nav className={`${isSidebarVisible ? "px-4" : "px-4"} space-y-3`}>
          {navigationItems
           .filter(item => hasPermission(item.label, "view")) 
           .map((item, index) => {
            const isActive =
              item.path === "/products"
                ? location.pathname.startsWith("/products")
                : location.pathname === item.path;
            return (
              <div
                key={item.path}
                className="relative"
                onMouseEnter={() => !isSidebarVisible && setHoveredItem(index)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <Link
                  id={item.path}
                  to={item.path}
                  className={`flex items-center ${
                    isSidebarVisible ? "px-3" : "px-2 justify-center"
                  } py-2.5 rounded-lg transition-all duration-200 ${
                    isActive
                      ? "bg-[#111827] text-[#05E27E] shadow-lg"
                      : "text-gray-900 hover:bg-gray-200"
                  }`}
                  onClick={() => handleNavClick(item.path)}
                >
                  <item.icon
                    className={`w-6 h-6 transition-all ${
                      isActive ? "text-[#05E27E]" : "text-gray-900"
                    }`}
                  />

                  {isSidebarVisible && (
                    <span className="ml-3 text-base font-medium">
                      {item.label}
                    </span>
                  )}
                </Link>

                {/* Improved tooltip positioning with portal */}
                {!isSidebarVisible && hoveredItem === index && (
                  <div
                    className="fixed whitespace-nowrap bg-white text-gray-800 px-3 py-1.5 rounded shadow-lg font-medium text-sm z-50"
                    style={{
                      left: "5.5rem", // Position right after the collapsed sidebar
                      top: `${
                        window.scrollY +
                        document
                          .getElementById(item.path)
                          ?.getBoundingClientRect().top +
                        12
                      }px`,
                    }}
                  >
                    {item.label}
                    {/* Triangle pointer */}
                    <div className="absolute left-0 top-1/2 transform -translate-x-1 -translate-y-1/2 border-solid border-transparent border-r-white border-l-0 border-t-4 border-b-4 border-r-8"></div>
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default SideNavBar;
